var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteBellInBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4B9BF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8148 13.7427L12.7069 11.8506C13.7878 10.7697 13.9602 9.06387 13.1194 7.79826C12.9009 7.45678 12.5388 7.09625 12.2062 6.88343C10.9361 6.03983 9.23029 6.21219 8.14937 7.29311L6.25731 9.18517L10.8148 13.7427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4398 14.1952L5.80598 9.56132C5.47956 9.71612 5.07806 9.66204 4.80834 9.39232L4.39402 9.80664L10.1945 15.6071L10.6088 15.1928C10.3391 14.9231 10.285 14.5216 10.4398 14.1952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5308 6.39522C12.7215 6.51761 12.9283 6.68634 13.1205 6.87852C13.3139 7.07193 13.4844 7.28091 13.6135 7.48281C13.6296 7.50703 13.6391 7.53384 13.6545 7.55833C13.8714 7.21839 13.8327 6.76126 13.536 6.4646C13.2391 6.1677 12.7813 6.12906 12.4414 6.34661C12.4704 6.3648 12.5021 6.37618 12.5308 6.39522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29492 12.538C6.14012 12.8644 6.1942 13.2659 6.46392 13.5356C6.73365 13.8054 7.13515 13.8594 7.46157 13.7046L6.29492 12.538Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(10 2.92892) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteBellInBlue);
export default __webpack_public_path__ + "static/media/white-bell-in-blue.9840f85b4c0deb6b9a42f2064a9291e3.svg";
export { ForwardRef as ReactComponent };